import React from "react";
import { FormattedMessage } from "react-intl";

const { BreadcrumbGroup, default: Breadcrumb } = require("@amzn/meridian/breadcrumb")

const breadCrumbMapping = {
    "ageingBoard": "Package Summary",
    "rtsBoard": "Package Summary",
    "dwellingBoard": "Package Summary",
    "sdDwellingBoard": "Package Summary",
    "packageSearch": "Package Search",
    "detailPage": "Search"
}

const breadCrumbMappingToStringId = {
    "Package Summary": "breadCrumb.packageSummary",
    "Package Search": "breadCrumb.packageSearch",
    "Search": "breadCrumb.search",
    "Associate Detail": "breadCrumb.associateDetail",
    "Container Detail": "breadCrumb.containerDetail",
    "Workcell Detail": "breadCrumb.workcellDetail",
    "Package Detail": "breadCrumb.packageDetail"
}

export function generateBreadCrumb(pathName, pageName) {
    let pathNames = pathName.split("/").filter(x => x);
    if (pathNames.length < 1) {
        return null;
    } else if (!(pathNames[0] in breadCrumbMapping)) {
        return null;
    }
    let breadCrumbInfo = [];
    let lastIdentifiedPage = pathNames[0];
    for (var index = 1; index < pathNames.length; index++) {
        if (pathNames[index] in breadCrumbMapping) {
            var link = `/${pathNames.slice(0, index).join("/")}`;
            breadCrumbInfo.push({"link": link, "name": breadCrumbMapping[lastIdentifiedPage]});
            lastIdentifiedPage = pathNames[index];
        }
    }
    var finalLink = `/${pathNames.join("/")}`;
    breadCrumbInfo.push({"link": finalLink, "name": breadCrumbMapping[lastIdentifiedPage]});

    return (
        <BreadcrumbGroup>
            {
                breadCrumbInfo.map((info) => {
                    return <Breadcrumb href={'#' + info.link}><FormattedMessage id={breadCrumbMappingToStringId[info.name]} defaultMessage={info.name}/></Breadcrumb>;
                })
            }
            <Breadcrumb><FormattedMessage id={breadCrumbMappingToStringId[pageName]} defaultMessage={pageName}/></Breadcrumb>
        </BreadcrumbGroup>
    )
}



// WEBPACK FOOTER //
// ./src/components/detailPages/BreadCrumbsUtils.js